export default "__VITE_ASSET__Ot9Ka7ht__"